export default "__VITE_PUBLIC_ASSET__2aad247a__"